import classNames from '@sindresorhus/class-names';

import styles from './Checkbox.module.scss';

type Props = {
  termsAccepted: boolean;
  toggleTerms: () => void;
  content: string;
  className?: string;
};

export const Checkbox = ({
  termsAccepted,
  toggleTerms,
  content,
  className,
}: Props) => {
  return (
    <div className={classNames(styles.terms, className)}>
      <input
        type="checkbox"
        id={'terms'}
        className={styles.checkbox}
        checked={termsAccepted}
        onChange={toggleTerms}
        data-testid={'checkbox_id'}
      />
      <label htmlFor={'terms'} />
      <div className={styles.description}>
        <p
          className={styles.description}
          itemProp="text"
          dangerouslySetInnerHTML={{__html: content}}
        />
      </div>
    </div>
  );
};
